import React, { useState, useEffect } from "react";
import css from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { getPaperList } from "../../../../api/index";
import { Pagination, ConfigProvider } from "antd";
import { useInView, animated } from "@react-spring/web";
import i18n from "i18next";
import enUS from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";


function Index() {
  const { t } = useTranslation();
  const [datalist, setDataList] = useState([]);

  const [refFirst, styleFirst] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  const getList = async () => {
    const res = await getPaperList();
    if (res.code === 200) {
      setDataList(res.data);
    } else {
      toast.error("获取数据失败", { position: "top-center" });
    }
  };


  useEffect(() => {
    getList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={css.contain}>
      <div className={css.maintitle}>{t("$singlee_nw3")}</div>
      <div className={css.first} ref={refFirst}>
        <animated.div style={styleFirst} className={css.inner}>
          {datalist.map((item, index) => {
            return (
              <div
                key={index}
                className={css.item}
                onClick={() => {
                  window.open(item.pdfUrl);
                }}
              >
                <img src={item.picUrl} alt={item.title} />
                <div className={css.title}>{item.title}</div>
              </div>
            );
          })}
        </animated.div>
      </div>

    </div>
  );
}

export default React.memo(Index);
